import React from 'react';
import { useSelector } from 'react-redux';

import SectionBuilder from '../PageBuilder/SectionBuilder/SectionBuilder';
import { SEARCH_PAGE_ASSET_NAME } from './SearchPage.duck';

/**
 * Renders the hosted "search-page" content asset (e.g. the "search-page-footer"
 * SectionArticleWithColumns section) at the bottom of the SearchPage.
 *
 * The asset is fetched in SearchPage.duck's loadData and stored in the shared
 * hostedAssets state; here we just read its sections and hand them to the
 * SectionBuilder (the same renderer PageBuilder uses).
 *
 * @component
 * @returns {JSX.Element|null}
 */
const SearchPageFooterSection = () => {
  const sections = useSelector(
    state => state.hostedAssets?.pageAssetsData?.[SEARCH_PAGE_ASSET_NAME]?.data?.sections
  );

  if (!sections || sections.length === 0) {
    return null;
  }

  return <SectionBuilder sections={sections} pageId={SEARCH_PAGE_ASSET_NAME} options={{}} />;
};

export default SearchPageFooterSection;
